import { CommentRefUrlSchema } from '@jotta/grpc-js-client/schema/CommentRefUrlSchema'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useCommentsRefParam() {
  const [search] = useSearchParams()
  const commentSearchParam = search.get('comment')
  const id = useMemo(() => {
    const parsed = CommentRefUrlSchema.safeParse(commentSearchParam)
    if (parsed.success) {
      return parsed.data.id
    }
    return ''
  }, [commentSearchParam])
  return id
}
